import WebSocketService from "@/services/webSocket";

export function getWfbWebSocketService(token, sessionId) {
  const url = `${import.meta.env.VITE_APP_AC_SERVER_WS_URL}/api/agentchat/in?token=${token}&session_id=${sessionId}`;
  return new WebSocketService(url);
}
